export default {
  // Risk Types
  质量风险: "Quality Risk",
  交付风险: "Delivery Risk",
  财务风险: "Financial Risk",
  成本风险: "Cost Risk",
  注册风险: "Registration Risk",
  其他风险: "Other Risk",

  // Risk Levels
  高: "High",
  中: "Medium",
  低: "Low",

  // Modal Titles
  通知供应商风险: "Notify Supplier Risk",
  查看供应商风险: "View Supplier Risk",
  编辑供应商风险: "Edit Supplier Risk",

  // Table Column Titles
  处理状态: "Processing Status",
  "供应商名称（中文）": "Supplier Name (Chinese)",
  "供应商名称（英文）": "Supplier Name (English)",
  风险等级: "Risk Level",
  发起人: "Initiator",
  发起部门: "Initiating Department",
  发起日期: "Initiation Date",
  操作: "Actions",

  // Status Values
  草稿: "Draft",
  待通知供应商: "Pending Supplier Notification",
  待供应商提供解决方案: "Awaiting Supplier Solution",
  解决方案审批中: "Solution Under Review",
  已驳回解决方案: "Solution Rejected",
  已完结: "Completed",
  未知: "Unknown",

  // Action Buttons
  编辑: "Edit",
  删除: "Delete",
  查看: "View",
  通知供应商: "Notify Supplier",

  // Confirmation Dialog
  删除确认: "Delete Confirmation",
  "确定要删除此风险等级吗？":
    "Are you sure you want to delete this risk level?",
  确定: "Confirm",
  取消: "Cancel",
  点击上传: "Click to Upload",

  // Search Fields
  供应商: "Supplier",
  物料: "Material",
  请输入供应商名称: "Enter supplier name",
  请输入物料名称: "Enter material name",
  请选择处理状态: "Select processing status",
  请选择发起人: "Select initiator",

  // Search Fields (Nested)

  searchFields: {
    supplier: "Supplier",
    material: "Material",
    materialCategory: "Material Category",
    materialName: "Material Name",
    riskType: "Risk Type",
    processingStatus: "Processing Status",
    initiator: "Initiator",
    supplierNameP: "Enter supplier name",
    materialNameP: "Enter material name",
    materialCategoryP: "Select material category",
    riskTypeP: "Select risk type",
    processingStatusP: "Select processing status",
    initiatorP: "Select initiator",
  },

  // Material Category Options
  电子元器件: "Electronic Components",
  机械零件: "Mechanical Parts",
  化工原料: "Chemical Materials",
  其他: "Others",

  // Risk Type Options (Search)
  交期风险: "Delivery Risk",
  价格风险: "Price Risk",
  信用风险: "Credit Risk",

  // List Title and Buttons
  供应商风险等级列表: "Supplier Risk Level List",
  登记供应商风险: "Register Supplier Risk",

  // Pagination
  共数据条: "Total {{totalCount}} records",

  // Form Labels
  员工姓名: "Employee Name",
  员工工号: "Employee ID",
  创建日期: "Creation Date",
  部门: "Department",
  岗位: "Position",
  邮箱: "Email",
  供应商信息: "Supplier Information",
  供应商编号: "Supplier Code",
  请输入供应商编号搜索: "Search by supplier code",
  供应商名称中文: "Supplier Name (Chinese)",
  供应商名称英文: "Supplier Name (English)",
  物料类别: "Material Category",
  二级物料类别: "Secondary Material Category",
  物料编号: "Material Code",
  请输入物料编号搜索: "Search by material code",
  物料名称: "Material Name",
  风险类型: "Risk Type",
  风险等级评估: "Risk Level Assessment",
  发现日期: "Discovery Date",
  期望解决日期: "Expected Resolution Date",
  风险描述: "Risk Description",
  相关证明文件: "Supporting Documents",
  供应商解决方案: "Supplier Solution",
  备注说明: "Remarks",
  评估信息: "Assessment Information",
  评估意见: "Assessment Opinion",
  意见说明: "Opinion Description",
  同意: "Agree",
  驳回: "Reject",
  由供应商编号自动填写: "Auto-filled by supplier code",

  // Form Placeholders
  请输入员工姓名: "Enter employee name",
  请输入员工工号: "Enter employee ID",
  请输入创建日期: "Enter creation date",
  请输入部门: "Enter department",
  请输入岗位: "Enter position",
  请输入邮箱: "Enter email",
  请选择物料类别: "Select material category",
  请选择二级物料类别: "Select secondary material category",
  请选择风险类型: "Select risk type",
  请选择风险等级评估: "Select risk level assessment",
  请选择发现日期: "Select discovery date",
  请选择期望解决日期: "Select expected resolution date",
  请输入风险描述: "Enter risk description",
  请上传相关证明文件: "Upload supporting documents",
  请输入备注说明: "Enter remarks",
  请选择评估意见: "Select assessment opinion",
  请输入意见说明: "Enter opinion description",

  // Form Validation Messages
  供应商编号必填: "Supplier Code is required",
  供应商名称中文必填: "Supplier Name (Chinese) is required",
  供应商名称英文必填: "Supplier Name (English) is required",
  物料类别必填: "Material Category is required",
  二级物料类别必填: "Secondary Material Category is required",
  物料名称必填: "Material Name is required",
  风险类型必填: "Risk Type is required",
  风险等级评估必填: "Risk Level Assessment is required",
  发现日期必填: "Discovery Date is required",
  期望解决日期必填: "Expected Resolution Date is required",
  风险描述必填: "Risk Description is required",
  相关证明文件必填: "Supporting Documents are required",

  // Messages
  生成失败: "Generation failed",
  提交成功: "Submitted successfully",
  提交失败: "Submission failed",
  已暂存: "Saved as draft",
  暂存失败: "Failed to save as draft",
  表单数据获取失败: "Failed to retrieve form data",
  已通知供应商: "Supplier notified",
  任务ID不存在无法通知供应商: "Cannot notify supplier: Task ID not found",
  通知供应商失败: "Failed to notify supplier",
  加载风险登记详情失败: "Failed to load risk registration details",
  删除成功: "Deleted successfully",

  // File Related
  暂无解决方案文件: "No solution files",

  // Data Loading Errors
  获取物料数据失败: "Failed to load material data",
  获取供应商数据失败: "Failed to load supplier data",

  // Others
  单号: "Form Number",
  加载中: "Loading",
};
